import React from 'react';

const Icon123OrientationUSofaBumperSectionalLeft = props => (
  <svg
    focusable="false"
    viewBox="0 0 1025 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <g>
      <path
        d="M724.05,80.07h216.75v216.75h-202.25c-8,0-14.5-6.5-14.5-14.5V80.07h0Z"
        transform="translate(1020.87 -643.98) rotate(90)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M993.05,38.08v41.99s0,216.75,0,216.75h-52.25s0-216.75,0-216.75h-206.49c-5.66,0-10.26-4.59-10.26-10.26v-31.73c0-5.66,4.59-10.26,10.26-10.26h248.48c5.66,0,10.26,4.59,10.26,10.26Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <g>
        <polygon
          points="940.8 296.82 940.8 730.32 724.05 730.32 724.05 513.57 724.05 296.82 940.8 296.82"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M846.8,616.75h23.49c5.07,0,9.18,4.11,9.18,9.18v259.82h-32.67c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
          transform="translate(107.3 1609.8) rotate(-90)"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M993.05,296.82v424.5c0,4.97-4.03,9-9,9h-43.25v-433.5h52.25Z"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
      </g>
      <line
        x1="940.8"
        y1="296.82"
        x2="724.05"
        y2="296.82"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
    </g>
    <g>
      <polygon
        points="724.05 80.07 724.05 296.82 507.3 296.82 290.55 296.82 290.55 80.07 724.05 80.07"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M299.55,27.83h415.5c4.97,0,9,4.03,9,9v43.25h-433.5v-43.25c0-4.97,4.03-9,9-9Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <g>
        <path
          d="M41.13,27.83h32.67v259.99c0,4.97-4.03,9-9,9h-23.67c-5.07,0-9.18-4.11-9.18-9.18V37.01c0-5.07,4.11-9.18,9.18-9.18Z"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M82.8,27.83h198.75c4.97,0,9,4.03,9,9v43.25H73.8v-43.25c0-4.97,4.03-9,9-9Z"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M73.8,287.82V80.07h216.75v281.11H73.8s-41.85,0-41.85,0v-64.36h32.85c4.97,0,9-4.03,9-9Z"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
      </g>
    </g>
  </svg>
);

export default Icon123OrientationUSofaBumperSectionalLeft;
